import { render, staticRenderFns } from "./ProfilePlayerCard.vue?vue&type=template&id=5c0bab8f&scoped=true"
import script from "./ProfilePlayerCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfilePlayerCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfilePlayerCard.vue?vue&type=style&index=0&id=5c0bab8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0bab8f",
  null
  
)

export default component.exports